import { render, staticRenderFns } from "./form.vue?vue&type=template&id=191dafa8&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=191dafa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191dafa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('191dafa8')) {
      api.createRecord('191dafa8', component.options)
    } else {
      api.reload('191dafa8', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=191dafa8&scoped=true&", function () {
      api.rerender('191dafa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/order/back/form/form.vue"
export default component.exports